module.exports = __webpack_public_path__ + "img/netvirtue.ad3c7b88.jpg";